import { cn } from '@/utils/styles.utils';

import styles from './RatingStars.module.css';

export const RatingStar = () => {
  const style = { '--rating': 1, '--max-rating': 1 } as React.CSSProperties;
  return <div className={cn(styles.stars, styles.stars_single)} style={style} />;
};
